var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43333 6.66658C7.79999 4.87325 5.93333 3.66658 3.84666 4.07992C2.32 4.38658 1.08 5.60658 0.76 7.13325C0.213334 9.71325 2.17333 11.9999 4.66666 11.9999C6.40666 11.9999 7.88666 10.8866 8.43333 9.33325H11.3333V10.6666C11.3333 11.3999 11.9333 11.9999 12.6667 11.9999C13.4 11.9999 14 11.3999 14 10.6666V9.33325C14.7333 9.33325 15.3333 8.73325 15.3333 7.99992C15.3333 7.26658 14.7333 6.66658 14 6.66658H8.43333ZM4.66666 9.33325C3.93333 9.33325 3.33333 8.73325 3.33333 7.99992C3.33333 7.26658 3.93333 6.66658 4.66666 6.66658C5.4 6.66658 6 7.26658 6 7.99992C6 8.73325 5.4 9.33325 4.66666 9.33325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.ebda373b6c02d5bf20771d1930695b01.svg";
export { ForwardRef as ReactComponent };